import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import _ from 'helpers/no_conflict_lodash';

class TagsApi {
  constructor(paths) {
    this.paths = paths;
  }

  searchTags(text, active_tags = []) {
    return axios.get(this.paths.tags, {
      params: {
        active_tags,
        search_text: text
      }
    }).then(response => response.data.tags);
  }

  createTag(tag) {
    return axios.post(this.paths.tags, {
      tag: {
        name: tag
      }
    }).then(response => response.data);
  }

  saveTag(tag) {
    return axios.put(this.paths.tags, {
      tag: tag
    }).then(response => response.data.tags);
  }

  deleteTag(tag) {
    return axios.delete(this.paths.tags, {
      data: {
        tag: tag
      }
    }).then(response => response.data.tags);
  }
}

export default TagsApi;
